import request from '@/services/helpers/request';
import { API_ROUTES } from '@/config';

export const fetchAll = async () => (await request.getInstance()).get(API_ROUTES.agentAccess.fetchAll);
export const remove = async id => (await request.getInstance()).delete(`${API_ROUTES.agentAccess.byId}/${id}`);
export const getById = async id => (await request.getInstance()).get(`${API_ROUTES.agentAccess.byId}/${id}`);
export const newItem = async (id, data) => (await request.getInstance()).post(`${API_ROUTES.agentAccess.newAccess}/${id}`, data);
export const change = async (id, data) => (await request.getInstance()).put(`${API_ROUTES.agentAccess.byId}/${id}`, data);
export const agentAccess = async id => (await request.getInstance()).get(`${API_ROUTES.agentAccess.agentAccess}/${id}`);
